import App from '@/models/App'
import Folder from '@/models/Folder'

export default class Document extends App {
    static get entity() {
        return 'Documents'
    }
    static fields() {
        return {
            id: this.attr(''),
            folderId: this.attr(''),
            userId: this.attr(''),
            name: this.attr(''),
            origin: this.attr(''),
            ext: this.attr(''),
            size: this.attr(''),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
            presignedUrl: this.attr(''),
            folder: this.belongsTo(Folder, 'folder_id'),
        }
    }
    static apiConfig = {
        actions: {
            find(folderId, documentId) {
                return this.get(`folders/${folderId}/documents/${documentId}`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.overallURL(),
                })
            },
            search(params) {
                return this.post(`/documents/search`, App.post(params), {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.overallURL(),
                })
            },
            create(folderId, params) {
                return this.post(
                    `/folders/${folderId}/documents`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.overallURL(),
                    }
                )
            },
            update(folderId, documentId, params) {
                return this.patch(
                    `folders/${folderId}/documents/${documentId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.overallURL(),
                    }
                )
            },
            destroy(folderId, documentId) {
                return this.delete(
                    `folders/${folderId}/documents/${documentId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.overallURL(),
                    }
                )
            },
        },
    }
}
